import { AppBar, Toolbar, Typography, Box } from '@material-ui/core';
import { Theme, makeStyles } from '@material-ui/core/styles';
//import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import IconButton from '@material-ui/core/IconButton';
import { Container } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  footerBar: {
    top: 'auto',
    bottom: 0,
    background: theme.palette.info.main,
  },
  toolBar: {
    minHeight: 40,
    flexGrow: 1,
  },
  toolbarButton: {
    color: 'white',
  },
  footerBarTypography: {
    fontSize: 'small',
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(2),
  },
  footerBarCopyrightTypography: {
    fontFamily: 'Hind',
    fontSize: 'small',
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(2),
    color: theme.palette.info.light,
  },
}));

const FooterBar = () => {
  const classes = useStyles();
  const currentYear = new Date().getFullYear();

  return (
    <AppBar position="sticky" className={classes.footerBar} component="footer">
      <Container>
        <Toolbar className={classes.toolBar}>
          <Box marginRight="auto">
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              size="medium"
              className={classes.toolbarButton}
            >
              {/* <ChatBubbleOutlineIcon />
              <Typography
                component="h5"
                color="inherit"
                display="inline"
                className={classes.footerBarTypography}
              >
                Feedback
              </Typography> */}
            </IconButton>
          </Box>
          <Box marginLeft="auto" flexWrap="wrap">
            <Typography
              component="h5"
              color="inherit"
              display="inline"
              className={classes.footerBarCopyrightTypography}
            >
              © {currentYear} Aire Logic Limited. All rights reserved
            </Typography>
            {/* <Typography
              component="h5"
              color="inherit"
              display="inline"
              className={classes.footerBarTypography}
            >
              Privacy Policy
            </Typography>
            <Typography
              component="h5"
              color="inherit"
              display="inline"
              className={classes.footerBarTypography}
            >
              Terms of Use
            </Typography> */}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default FooterBar;
